
.input-message {
  color: crimson;
  padding: 0px 18px;
}

.post-error {
  color: crimson;
  font-size: 18px;
  padding: 18px;
  max-width: 350px;
  width: 80vw;
}

.post-success {
  min-height: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.post-success-icon {
  color: #008478;
  font-size: 56px !important;
}

.post-success-message {
  text-align: center;
  font-family: 'Roboto', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 28px;
  padding-bottom: 18px;
}


.input-item {
}

.field-container {
  position: relative;
  display: inline;
}

.invisible {
  opacity: 0;
}

.field-container-50 {
  width: 50%;
  min-width: 230px;
  flex-grow: 1;
}
@media only screen and (max-width: 500px)  {
  .field-container-50 {
    /* width: 80vw; */
    /* min-width: 200px; */
    max-width: 99vw;
    flex-grow: 1;
  }
}

.field-container-dddphone {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap !important;
  align-items: start;
  justify-content: start;
}

.field-container-ddd {
  width: 20%;
  min-width: 70px !important;
}

.field-container-phone {
  width: 80%;
  min-width: 80px !important;
}


.line-signup-finalize {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 8px 9px;
}

.line-signup-container {
  min-width: 400px;
  /* width: 86vw; */
  max-width: 100%;
  margin: 8px;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: stretch;
}

.danger {
  color: var(--ion-color-danger) !important;
}
.secondary {
  color: var(--ion-color-secondary) !important;
}